// Shared scene/node status helpers for TouchTour Studio.
//
// A node is "linked" when it has at least one outgoing navigation hotspot
// (link / fade / elevate-up / elevate-down), otherwise it is "unlinked".
// Used by WP-D (node border colours + START badge) and reusable by later
// work packages (e.g. WP-F editor alerts).

export const LINK_HOTSPOT_TYPES = ["link", "fade", "elevate-up", "elevate-down"];

// Returns 'linked' | 'unlinked' based on an image's navigation hotspots.
export const getLinkStatus = image => {
  const hotspots = image?.hotspots ?? [];
  const hasLink = hotspots.some(hotspot =>
    LINK_HOTSPOT_TYPES.includes(hotspot?.type),
  );
  return hasLink ? "linked" : "unlinked";
};

// "placed" = the scene exists on the board (in tour.data.images).
// tourImages may be the images map (object keyed by id) or an array.
export const isPlaced = (image, tourImages) => {
  if (!image) return false;
  if (Array.isArray(tourImages)) {
    return tourImages.some(item => item?.id === image.id);
  }
  return Boolean(tourImages?.[image.id]);
};

// Resolves the START node id for a tour.
// Prefers the explicit tour.data.startImageId; falls back to the first placed
// image for older tours that never set one; null when there are no images.
export const getStartImageId = tour => {
  const images = tour?.data?.images ?? {};
  const explicit = tour?.data?.startImageId;
  if (explicit && images[explicit]) return explicit;

  const ids = Object.keys(images);
  return ids.length > 0 ? ids[0] : null;
};
